import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=77618372"
import script from "./TicketView.vue?vue&type=script&lang=js"
export * from "./TicketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports